import React from 'react';
import MessagePrompter from "../../components/prompts/MessagePrompter";
import { VisageEditorWindowModes } from "../../interfaces/VisageUI";
import store from "../../state/store";
import Scenario from "../scenarioElements/Scenario";
import Step from "../scenarioElements/Step";
import { CustomEventTypes } from '../../globals';

export default class UIUtils
{
	/**
	 * Finds the first step with an active ui template of the given template type
	 *
	 * @static
	 * @param {*} templateType
	 * @returns {Step} the first step found to have an active ui template of the given template type
	 * @memberof Utils
	 */
	static findStepWithUiTemplate(templateType): Step | undefined
	{
		for(const [key, value] of Object.entries<any>(store.getState().uiModule.ui))
		{
			if(value["slide"] === templateType)
			{
				return Scenario.getStep(key);
			}
		}
	}

	/**
	 * Checks if the user is currently editing a visage template
	 *
	 * @static
	 * @return {*}  {boolean}
	 * @memberof UIUtils
	 */
	static isEditingVisageTemplate(): boolean
	{
		return store.getState().visageModule.editorMode === VisageEditorWindowModes.Template;
	}

	/**
	 * Generates a dialog to confirm the user's intent to exit the visage template editor
	 *
	 * @static
	 * @param {() => void} continueCallback
	 * @memberof UIUtils
	 */
	static generateExitVisageTemplateEditorDialog(continueCallback: () => void): void
	{
		MessagePrompter.showMessage(
			{
				title: "Save Template",
				icon: <></>,
				content:
					<>
						You are editing a new, or source template and need to save, or<br/>
						discard the changes to change steps, or to simulate the project.
					</>,
				actions: [
					{
						label: "Save Changes",
						onClick: () => 
						{
							document.dispatchEvent(new CustomEvent(CustomEventTypes.onSaveTemplateChanges));
							continueCallback();
						},
					},
					{
						label: "Keep Editing",
					},
					{
						label: "Discard Changes",
						onClick: () => 
						{
							document.dispatchEvent(new CustomEvent(CustomEventTypes.onDiscardTemplateChanges));
							continueCallback();
						},
					},
				]
			}
		)
	}
}
